import type { GeneratedImageEntry } from './mergedHtmlExtractImagePrompts'

export const GENERATE_CORPORATE_RESOURCES = 'GENERATE_CORPORATE_RESOURCES'

export type ParsedCorporateResourcesGeneration = {
  type?: string
  status?: string
  generationId?: number
  generation_id?: number
  projectId?: number
  project_id?: number
  mergedHtml?: string
  reference_unit_id?: string
  generated_images?: GeneratedImageEntry[]
}

export function parseGeneratedImages(raw: unknown): GeneratedImageEntry[] {
  if (!Array.isArray(raw)) return []
  const entries: GeneratedImageEntry[] = []
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue
    const o = item as Record<string, unknown>
    const image_url =
      (typeof o.image_url === 'string' && o.image_url) ||
      (typeof o.imageUrl === 'string' && o.imageUrl) ||
      ''
    const mime_type =
      (typeof o.mime_type === 'string' && o.mime_type) ||
      (typeof o.mimeType === 'string' && o.mimeType) ||
      'image/png'
    if (!image_url.trim()) continue
    entries.push({ image_url: image_url.trim(), mime_type })
  }
  return entries
}

function toNumber(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (
    typeof value === 'string' &&
    value.trim() &&
    !Number.isNaN(Number(value))
  ) {
    return Number(value)
  }
  return undefined
}

export function parseCorporateResourcesGeneration(
  raw: unknown
): ParsedCorporateResourcesGeneration | null {
  try {
    let data: unknown = raw
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }
    if (
      data &&
      typeof data === 'object' &&
      'data' in (data as Record<string, unknown>)
    ) {
      const wrapped = (data as { data: unknown }).data
      data = typeof wrapped === 'string' ? JSON.parse(wrapped) : wrapped
    }
    if (!data || typeof data !== 'object') return null
    const o = data as Record<string, unknown>
    const generatedRaw = o.generated_images ?? o.generatedImages
    const generationId = toNumber(o.generationId ?? o.generation_id)
    const projectId = toNumber(o.projectId ?? o.project_id)
    const mergedHtml =
      (typeof o.mergedHtml === 'string' && o.mergedHtml) ||
      (typeof o.merged_html === 'string' && o.merged_html) ||
      undefined
    return {
      type: o.type as string | undefined,
      status: o.status as string | undefined,
      generationId,
      generation_id: generationId,
      projectId,
      project_id: projectId,
      mergedHtml,
      reference_unit_id: o.reference_unit_id as string | undefined,
      generated_images: parseGeneratedImages(generatedRaw)
    }
  } catch {
    return null
  }
}
